import { render } from "./opsManage.vue?vue&type=template&id=042ed658&scoped=true"
import script from "./opsManage.vue?vue&type=script&lang=js"
export * from "./opsManage.vue?vue&type=script&lang=js"

import "./opsManage.vue?vue&type=style&index=0&id=042ed658&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-042ed658"]])

export default __exports__